import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { ProductService } from 'src/services/productservice';
import { environment } from '@env/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-islands-overview',
  templateUrl: './islands-overview.component.html',
  styleUrls: ['./islands-overview.component.scss'],
})
export class IslandsOverviewComponent implements OnInit {
  islandsData: any[] = [];
  categoryData: any[] = [];
  catData: any = {};
  islandIndex = 0;
  dynamicFontSize: number = 6; // Default size in vmin
  dynamicDescriptionFontSize: number = 1.5; // D
  @ViewChildren('videoPlayer') videoPlayers: QueryList<ElementRef<HTMLVideoElement>>;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
    private http: HttpClient,
    private productService: ProductService
  ) {}

  ngOnInit(): void {
    this.getIslandsData();
    this.calculateFontSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.calculateFontSize();
  }

  calculateFontSize() {
    const width = window.innerWidth;
    const height = window.innerHeight;

    // Calculate font size based on viewport dimensions
    this.dynamicFontSize = Math.min(width, height) * 0.06; // 8% of the smaller dimension
    this.dynamicDescriptionFontSize = Math.min(width, height) * 0.015; // 1.5% of the smaller dimension

    // Ensure font size stays within reasonable limits
    this.dynamicFontSize = Math.max(40, Math.min(this.dynamicFontSize, 100));
    this.dynamicDescriptionFontSize = Math.max(8, Math.min(this.dynamicDescriptionFontSize, 20));

    // Convert to vmin units
    this.dynamicFontSize = (this.dynamicFontSize / Math.min(width, height)) * 100;
    this.dynamicDescriptionFontSize = (this.dynamicDescriptionFontSize / Math.min(width, height)) * 100;
  }

  private getYoutubeVideoId(url: string): string {
    if (!url) return '';

    let videoId = '';
    if (url.includes('watch?v=')) {
      videoId = url.split('v=')[1].split('&')[0];
    } else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1];
    } else if (url.includes('embed/')) {
      videoId = url.split('embed/')[1];
    }
    return videoId;
  }

  private createSafeYoutubeUrl(videoId: string): SafeResourceUrl {
    if (!videoId) return '';

    const embedUrl = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=1&mute=1&controls=0&showinfo=0&rel=0&loop=1&playlist=${videoId}&modestbranding=1&fs=1&playsinline=1&version=3&origin=${window.location.origin}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  // Function to check if a URL is a GIF
  isGifFile(url: string): boolean {
    return url.toLowerCase().endsWith('.gif');
  }

  getIslandsData() {
    this.productService.get360Info().then((result) => {
      result.forEach((element: any) => {
        const bannerVideo = element.field_banner_video;
        const isGif = bannerVideo ? this.isGifFile(bannerVideo) : false;

        // Process YouTube URL once during data loading
        const videoId = this.getYoutubeVideoId(element.field_youtube_url);
        const safeYoutubeUrl = videoId ? this.createSafeYoutubeUrl(videoId) : null;

        const json = {
          name: element.title,
          description: element.body,
          id: element.field_listing_id,
          image: environment.adminBaseURL.toLowerCase() + '/' + element.field_banner_image,
          video: environment.adminBaseURL.toLowerCase() + '/' + bannerVideo,
          youtubeurl: element.field_youtube_url || '',
          safeYoutubeUrl: safeYoutubeUrl, // Store the processed URL
          isGif: isGif,
          route: 'listingdetails',
          routeParam: element.field_listing_id,
          url: 'listingdetails/' + element.field_listing_id,
          full_screen_url: element.field_full_screen_url,
        };
        this.islandsData.push(json);
      });

      // Initialize video players after data is loaded
      this.videoPlayers.forEach((videoElement, index) => {
        if (index === this.islandIndex && !this.islandsData[index].youtubeurl && !this.islandsData[index].isGif) {
          videoElement.nativeElement.play();
        }
      });
    });
  }

  updateIsland() {
    this.categoryData = this.catData[this.islandIndex];
    // Only play videos (not YouTube or GIFs) when needed
    this.videoPlayers.forEach((videoElement, index) => {
      if (index === this.islandIndex && !this.islandsData[index].youtubeurl && !this.islandsData[index].isGif) {
        videoElement.nativeElement.play();
      }
    });
  }

  exploreNow() {
    const activeIslandId = this.islandsData[this.islandIndex].id;
    this.router.navigate(['/listingdetails', activeIslandId]);
  }

  fullScreen() {
    const activeIslandUrl = this.islandsData[this.islandIndex].full_screen_url;
    //this.router.navigate(['/explore-island', activeIslandId]);
    window.open(activeIslandUrl, '_blank');
  }

  goToPrevIsland() {
    if (this.islandIndex <= 0) {
      this.islandIndex = this.islandsData.length - 1;
    } else {
      this.islandIndex--;
    }
    this.updateIsland();
  }

  goToNextIsland() {
    if (this.islandIndex >= this.islandsData.length - 1) {
      this.islandIndex = 0;
    } else {
      this.islandIndex++;
    }
    this.updateIsland();
  }

  onCategorySelection(index: any) {
    this.islandIndex = index;
  }
}
